module.exports = __webpack_public_path__ + "static/media/ls.fde5a48f.svg";